var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15V16H3.5V5H7V3H3.5C2.4 3 1.5 3.9 1.5 5V16C1.5 17.1 2.4 18 3.5 18H7.5V19H5.5V21H17.5V19H15.5V18H19.5C20.6 18 21.5 17.1 21.5 16V15C21.5 15 20.6 15 19.5 15Z",
    fill: "#12324F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 3.77539C22.5 3.01914 21.87 2.40039 21.1 2.40039H9.9C9.13 2.40039 8.5 3.01914 8.5 3.77539V12.0254C8.5 12.7816 9.13 13.4004 9.9 13.4004H21.1C21.87 13.4004 22.5 12.7816 22.5 12.0254V3.77539ZM19.5 4.40039L15.5 6.52539L11.5 4.40039H19.5ZM20.6333 11.5671H10.3667V5.60872L15.5 8.58789L20.6333 5.60872V11.5671Z",
    fill: "#12324F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.dc416649342361eec45c90d161614bf8.svg";
export { ForwardRef as ReactComponent };